import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import hearingService from 'services/hearing.service'
import { HttpErrorType } from 'types/http.type'
import { useSnackBar } from 'contexts/snackbar.context'
import { useBackdrop } from 'contexts/backdrop.context'
import { errorColor, errorMessage } from 'utils/error.util'

export const useNewHearing = (oldHearingId?: string) => {
  const navigate = useNavigate()
  const { showSnackBar } = useSnackBar()
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()

  const [hearingId, setHearingId] = useState<string | undefined>(oldHearingId)
  const [isFinalized, setIsFinalized] = useState<boolean>(true)

  const handleCreateHearing = async () => {
    handleBackdropOpen()
    await hearingService
      .create()
      .then((response) => {
        setHearingId(String(response.data.idOitiva))
        navigate(`/nova-oitiva/${response.data.idOitiva}`, { replace: true })
      })
      .catch((error: HttpErrorType) => {
        showSnackBar(errorMessage(error), errorColor(error))
        navigate(`/`, { replace: true })
      })
      .finally(() => handleBackdropClose())
  }

  const handleFindById = async () => {
    handleBackdropOpen()
    await hearingService
      .findById(oldHearingId)
      .then((response) => {
        if (response.data.status !== 'FINALIZADO') {
          setIsFinalized(false)
        }
      })
      .catch((error: HttpErrorType) => showSnackBar(errorMessage(error), 'error'))
      .finally(() => handleBackdropClose())
  }

  useEffect(() => {
    ;(async () => {
      if (!hearingId || !oldHearingId) {
        await handleCreateHearing()
      } else {
        await handleFindById()
      }
    })()
  }, [oldHearingId, hearingId])

  return { hearingId, isFinalized }
}
